var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('SambaGlobalSettingsProject',{attrs:{"projectTypeId":_vm.projectTypeId},on:{"done":_vm.onDone,"cancel":_vm.onCancel}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }